import React from 'react';
import { Button } from '../components/Button';
import { Phone } from 'lucide-react';
export function AboutPage() {
  return <main className="flex-grow bg-black" data-id="element-126">
      {/* Hero */}
      <section className="pt-32 pb-12 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto text-center" data-id="element-127">
        <h1 className="text-4xl sm:text-5xl font-bold text-white mb-6" data-id="element-128">
          About Me
        </h1>
        <p className="text-xl text-gray-300 max-w-2xl mx-auto" data-id="element-129">
          Martial artist, coach, and content creator based in Warsaw
        </p>
      </section>

      {/* Story Section */}
      <section className="py-12 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto" data-id="element-130">
        <div className="bg-gray-900 border border-gray-800 rounded-2xl shadow-sm p-8 md:p-12" data-id="element-131">
          <div className="prose prose-lg text-gray-300 mx-auto" data-id="element-132">
            <div className="aspect-video w-full bg-gray-800 rounded-xl mb-8 overflow-hidden border border-gray-700" data-id="element-133">
              <img src="https://images.unsplash.com/photo-1517836357463-d25dfeac3438?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80" alt="Training in gym" className="w-full h-full object-cover" data-id="element-134" />
            </div>

            <h3 className="text-2xl font-bold text-white mb-4" data-id="element-135">My Journey</h3>
            <p className="mb-6 text-gray-300" data-id="element-136">
              I discovered martial arts years ago, and it completely changed my
              life. What started as a way to get fit quickly became a passion
              that taught me discipline, respect, and resilience.
            </p>
            <p className="mb-6 text-gray-300" data-id="element-137">
              After years of training and competing, I decided to dedicate
              myself to teaching others. I believe that martial arts is for
              everyone, regardless of age or fitness level.
            </p>
            <p className="text-gray-300" data-id="element-138">
              Today, I coach clients in Warsaw and create content to reach a
              global audience. My approach combines traditional techniques with
              modern training methods to help you achieve your goals safely and
              effectively.
            </p>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="py-16 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-139">
        <h2 className="text-3xl font-bold text-white text-center mb-12" data-id="element-140">
          What I Stand For
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-141">
          {[{
          title: 'Discipline',
          desc: "Consistency over intensity. Showing up even when you don't feel like it."
        }, {
          title: 'Growth',
          desc: 'Always learning, always improving. Embracing the beginner mindset.'
        }, {
          title: 'Community',
          desc: 'Lifting each other up. Training is personal, but the journey is shared.'
        }].map((value, idx) => <div key={idx} className="bg-gray-900/50 border border-gray-800 p-8 rounded-xl hover:border-[#D4FF00]/30 transition-colors" data-id="element-142">
              <h3 className="text-xl font-bold text-white mb-3" data-id="element-143">
                {value.title}
              </h3>
              <p className="text-gray-300" data-id="element-144">{value.desc}</p>
            </div>)}
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 text-center bg-gradient-to-b from-gray-900 to-black border-t border-gray-800 mt-12" data-id="element-145">
        <h2 className="text-3xl font-bold text-white mb-6" data-id="element-146">
          Ready to start your journey?
        </h2>
        <p className="text-gray-300 max-w-2xl mx-auto mb-8" data-id="element-147">
          Whether you want to get in shape, learn self-defense, or build
          confidence, I'm here to help you reach your potential.
        </p>
        <Button variant="primary" size="lg" href="tel:+48536052998" data-id="element-148">
          <Phone className="w-5 h-5 mr-2" data-id="element-149" />
          Book Free Consultation
        </Button>
      </section>
    </main>;
}